import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { DuplicateBorrowers } from 'app/models/dto/duplicate-borrowers.model';

@Injectable({
  providedIn: 'root'
})
export class DuplicateBorrowerService {

  constructor(private http: ApiHttpClient) { }

  getDuplicateBorrowers(borrowerId: number): Observable<DuplicateBorrowers> {
    return this.http.get<any>(`${environment.API_URL}/duplicates/${borrowerId}`);
  }

}
